import { FC } from "react";

import { ACCESS_ID_QUERY_PARAM } from "components/constants";
import { useIsAssessing } from "components/materials/section/assessment/hooks";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { selectSortedSubmissionsByAccessId } from "store/selectors";
import { useListSelector } from "store/store-hooks";
import { useQueryParam } from "utils/routing";

interface OlderSubmissionAssessedBannerProps {
  pageId: string;
}

export const OlderSubmissionAssessedBanner: FC<OlderSubmissionAssessedBannerProps> = ({
  pageId,
}) => {
  const isAssessing = useIsAssessing();
  const selectedAccessId = useQueryParam(ACCESS_ID_QUERY_PARAM);

  // Newest-first; only official_at is read below.
  const userSubmissions = useListSelector(
    (s) => selectSortedSubmissionsByAccessId(s, pageId, selectedAccessId),
    ["official_at"],
  );

  if (!selectedAccessId || userSubmissions.length === 0 || !isAssessing) {
    return null;
  }

  const officialSubmissionIndex = userSubmissions.findIndex((s) => s.official_at);

  // Newest-first: newer submissions sit before the official one.
  // TODO: This shows the banner even if the instructor is viewing the older submission - which
  // should probably instead show a different banner saying there are newer unassessed submissions.
  if (officialSubmissionIndex > 0) {
    // Chronological submission number (oldest = 1), matching SubmissionMenu labeling.
    const assessmentIndex = userSubmissions.length - officialSubmissionIndex;
    return (
      <Banner className="page-block-width" kind="warning">
        {t("warning.older_submission_has_already_been_assessed", {
          assessmentIndex,
        })}
      </Banner>
    );
  }

  return null;
};
